import React, { useState } from 'react'
import { useAuth } from '../auth/useAuth'
import { Offcanvas, ListGroup } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Version from '../../version'

export default function CabeceraMovil({rol}) {
	const { t } = useTranslation()
	const { pathname } = useLocation()
    const { clientauth, logoutClient } = useAuth()
    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const isActive = (path) => {
        const current = pathname.replace(/^\/+/, '')
        return current === path || current.startsWith(path + '/')
    }

    const adminLinks = [
        { to: `/${t('url.admin')}/${t('url.dashboard')}`, icon: 'fas fa-chart-pie', label: t('menu.index') },
        { to: `/${t('url.admin')}/${t('url.users')}`, icon: 'fas fa-users', label: t('menu.users') },
        { to: `/${t('url.admin')}/${t('url.products')}`, icon: 'fas fa-barcode', label: t('menu.products') },
        { to: `/${t('url.admin')}/${t('url.departments')}`, icon: 'fas fa-building', label: t('menu.departments') },
        { to: `/${t('url.admin')}/${t('url.delegations')}`, icon: 'fas fa-warehouse', label: t('menu.delegations') },
        { to: `/${t('url.admin')}/${t('url.productStates')}`, icon: 'fas fa-tags', label: t('menu.productStates') },
        { to: `/${t('url.admin')}/${t('url.productTemplates')}`, icon: 'fas fa-layer-group', label: t('menu.productTemplates') },
        { to: `/${t('url.admin')}/${t('url.chatbot')}`, icon: 'fas fa-comment-dots', label: t('menu.chatbot') },
    ]

    const departmentLinks = [
        { to: `/${t('url.department')}/${t('url.dashboard')}`, icon: 'fas fa-chart-pie', label: t('menu.index') },
        { to: `/${t('url.department')}/${t('url.products')}`, icon: 'fas fa-barcode', label: t('menu.products') },
        { to: `/${t('url.department')}/${t('url.chatbot')}`, icon: 'fas fa-comment-dots', label: t('menu.chatbot') },
    ]

    const commercialLinks = [
        { to: `/${t('url.commercial')}/${t('url.products')}`, icon: 'fas fa-barcode', label: t('menu.products') },
        { to: `/${t('url.commercial')}/${t('url.chatbot')}`, icon: 'fas fa-comment-dots', label: t('menu.chatbot') },
    ]

    let links = []
    if (rol === 'admin') links = adminLinks
    else if (rol === 'department') links = departmentLinks
    else if (rol === 'commercial') links = commercialLinks

  	return (
        <>
            <div id="cabecera" className="d-lg-none d-flex justify-content-between align-items-center px-3">
                <Link to={`/${t('url.' + rol)}/${t('url.dashboard')}`} className="d-flex align-items-center text-decoration-none">
                    <img id='logo' src='/images/logo-inicio.png' alt='logo' height={28} />
                </Link>
                <button
                    className="btn btn-third p-2 border-0 d-flex align-items-center justify-content-center"
                    onClick={handleShow}
                    style={{ width: 40, height: 40, fontSize: 20, color: 'var(--neutral-600)' }}
                    aria-label="Menu"
                >
                    <i className="fas fa-bars"></i>
                </button>
            </div>

            <Offcanvas show={show} onHide={handleClose} placement="start" className="mobile-offcanvas">
                <Offcanvas.Header closeButton className="border-bottom" style={{ padding: '16px' }}>
                    <img src='/images/logo-inicio.png' alt='logo' height={32} />
                </Offcanvas.Header>
                <Offcanvas.Body className="p-2 d-flex flex-column">
                    <ListGroup variant="flush" className="flex-grow-1">
                        {links.map((link, i) => (
                            <ListGroup.Item
                                key={i}
                                as={Link}
                                to={link.to}
                                onClick={handleClose}
                                action
                                active={isActive(link.to)}
                                className="d-flex align-items-center gap-3 border-0 rounded-3 py-3 px-3 mb-1"
                                style={{
                                    fontSize: 15,
                                    fontWeight: isActive(link.to) ? 600 : 500,
                                    color: isActive(link.to) ? 'white' : 'var(--neutral-700)',
                                    background: isActive(link.to) ? 'var(--primary)' : 'transparent',
                                    transition: 'all 0.15s ease',
                                }}
                            >
                                <i className={link.icon} style={{
                                    width: 20,
                                    textAlign: 'center',
                                    color: isActive(link.to) ? 'white' : 'var(--neutral-400)',
                                    fontSize: 16,
                                }}></i>
                                {link.label}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>

                    <div className="border-top pt-3 mt-2 px-2">
                        <div className="d-flex align-items-center gap-3 mb-3 px-1">
                            <div
                                className="avatar-initials d-flex align-items-center justify-content-center"
                                style={{ width: 36, height: 36, fontSize: 13, flexShrink: 0 }}
                            >
                                {(clientauth?.name || clientauth?.username || 'U').charAt(0).toUpperCase()}
                            </div>
                            <div className="min-w-0" style={{ flex: 1 }}>
                                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--neutral-900)', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {clientauth?.name || clientauth?.username}
                                </div>
                                <div style={{ fontSize: 12, color: 'var(--neutral-400)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {clientauth?.email}
                                </div>
                            </div>
                        </div>
                        <ListGroup.Item
                            as={Link}
                            to="/"
                            onClick={() => { handleClose(); logoutClient() }}
                            action
                            className="d-flex align-items-center justify-content-center gap-2 border-0 rounded-3 py-3"
                            style={{ fontSize: 14, fontWeight: 500, color: 'var(--neutral-600)' }}
                        >
                            <i className="fas fa-sign-out-alt"></i>
                            {t('global.logout')}
                        </ListGroup.Item>
                        <div className="text-center mt-3" style={{ fontSize: 11, color: 'var(--neutral-400)' }}>
                            <Version />
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
	)
}
